module.exports = __webpack_public_path__ + "../static/img/marker.19436175.png";